// extracted by mini-css-extract-plugin
export default {"hero":"HeroImg_hero__idk6c","swap-image":"HeroImg_swap-image__6DKlH"};